import React from "react";
import { useSearchParams } from "react-router-dom";
import ParteFormulario from "./ParteFormulario";

/**
 * ✅ Wrapper de compatibilidad
 *
 * Antes existía una pantalla "PartesEditar" reducida.
 * Ahora la edición usa el MISMO formulario completo (ParteFormulario)
 * en modo edición, leyendo ?id=<parteId>.
 */
export default function PartesEditar() {
  const [sp] = useSearchParams();
  const parteId = sp.get("id") || "";

  // Si por algún motivo llegan sin id, igual renderizamos el formulario (mostrará mensaje).
  return <ParteFormulario key={parteId || "__noid__"} />;
}
